import LtiContext from '@/models/LtiContext.js';
import LtiToolDeployment from '@/models/LtiToolDeployment.js';
import Model from '@/models/Model.js';

export default class LtiResourceLink extends Model {
    static entity = 'lti_resource_links';

    static fields() {
        return {
            id: this.attr(null),
            title: this.attr(null),
            description: this.attr(null),
            lti_tool_deployment_id: this.attr(null),
            lti_context_id: this.attr(null),
            resourceable_id: this.attr(null),

            ...super.fields(),

            deployment: this.belongsTo(LtiToolDeployment, 'lti_tool_deployment_id'),
            context: this.belongsTo(LtiContext, 'lti_context_id'),
        };
    }
}
